module.exports = __webpack_public_path__ + "static/media/event_popup02.fb545ad1.webp";